<template>
  <div>
    <b-row>
      <b-col md="12" class="settings-panel">
        <div class="card">
          <div class="card-header text-center">
            Email Settings
          </div>
          <b-row>
            <b-col class="settings-panel-body emailsettings">
              <div class="card-block">
                <b-form>
                  <b-form-group id="exampleInputGroup1" label="From email" label-for="email">
                    <div class="label-desc">
                      Default: <b>{{defaultEmail}}</b> You can change it below.
                    </div>
                    <b-form-input class="col-md-4" id="email" type="text" v-model="form.fromEmail" required placeholder="samplemail@example.com">
                    </b-form-input>
                  </b-form-group>
                  <b-form-group id="exampleInputGroup2" label="From name" label-for="name">
                    <div class="label-desc">
                      Default: <b>InfiniteWP</b> You can change it below.
                    </div>
                    <b-form-input class="col-md-4" id="name" type="text" v-model="form.fromName" required>
                    </b-form-input>
                  </b-form-group>
                  <div class="helper-text">
                    <info-round-icon class="icon-default inforound absolute"></info-round-icon>
                    <span class="pl-4">To use the default From email, empty this field and Save Changes.</span>
                  </div>
                </b-form>
                  <hr>
                <b-form class="mb-0">
                  <b-form-group label="SMTP Options" label-for="checkboxes2">
                    <div class="label-desc">
                      You can send your emails via SMTP instead of relying on the server mail function.
                    </div>

                    <b-form-checkbox v-model="form.smtpSettings.useSmtp" :value="1" :unchecked-value="0">Use SMTP to send email</b-form-checkbox>
                    <b-form-group class="pl-4" v-if="form.smtpSettings.useSmtp==1">
                      <div class="pt-1">
                        <a class="helper-links" target="_blank" :href="appInfo.SUPPORT_URL+'support/solutions/articles/211292-how-to-set-up-smtp-for-gmail'+appInfo.GA_HELP_TRACKING">See Instructions</a>
                      </div>
                      <div class="label-desc">
                        For Gmail - The account email will be used instead of the specified From email.
                      </div>
                      <div class="label-desc">
                        For Yahoo Mail - You have to add the account email as the From email. Only then will it work.
                      </div>
                      <b-row class="pt-2">
                        <b-col cols="4" class="pl-0">
                          <b-form-group class="pl-0" id="exampleInputGroup3" label="SMTP Host" label-for="smtp_host">
                            <b-form-input id="smtp_host" type="text" v-model="form.smtpSettings.smtpHost" required>
                            </b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col cols="4" class="pl-0">
                          <b-form-group class="pl-0" id="exampleInputGroup3" label="SMTP Port" label-for="smtp_port">
                            <b-form-input id="smtp_port" type="text" v-model="form.smtpSettings.smtpPort" required>
                            </b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col class="pl-0">
                          <b-form-group label="Encryption" class="p-0 no-label-margin">
                            <b-form-radio-group name="encryption" v-model="form.smtpSettings.smtpEncryption">
                              <b-form-radio value="no">No</b-form-radio>
                              <b-form-radio value="ssl">SSL</b-form-radio>
                              <b-form-radio value="tls">TLS</b-form-radio>
                            </b-form-radio-group>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="4" class="pl-0">
                          <b-form-group class="pl-0" id="iwp_password_smtp__group" label="Username/Email" label-for="smtp_username">
                            <b-form-input id="smtp_username" type="text" v-model="form.smtpSettings.smtpAuthUsername" required autocomplete="off">
                            </b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col cols="4" class="pl-0">
                          <b-form-group class="pl-0" id="iwp_password_smtp_group" label="Password" label-for="iwp_password_smtp">
                            <password-input idFor="iwp_password_smtp" v-model="form.smtpSettings.smtpAuthPassword"></password-input>
                          </b-form-group>
                        </b-col>
                        <b-col class="pl-0">
                          <b-form-group label="Authentication" class="p-0 no-label-margin">
                            <b-form-radio-group name="authentication" v-model="form.smtpSettings.smtpAuth">
                              <b-form-radio value="0">No</b-form-radio>
                              <b-form-radio value="1">Yes</b-form-radio>
                            </b-form-radio-group>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-form-group>

                  </b-form-group>
                </b-form>
              </div>
            </b-col>
          </b-row>
          <div class="card-footer text-muted text-right">
            <b-btn variant="primary" size="sm" @click="sendTestEmail()" v-if="form.smtpSettings.useSmtp==1">Send Test Email
              <spinner size="small" v-if="buttonLoaders.sendTestEmail"></spinner>
            </b-btn>
            <b-btn variant="primary" size="sm" @click="save" :disabled="buttonLoaders.saveChanges">Save Changes
              <spinner size="small" v-if="buttonLoaders.saveChanges"></spinner>
            </b-btn>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import PasswordInput from '../Common/PasswordInput';
import InfoRoundIcon from '../../assets/inforound.svg';
export default {
  name: 'emailsettings',
  props: ['settings'],
  components: {
    PasswordInput,
    InfoRoundIcon
  },
  created() {
    let settings = _.cloneDeep(this.settings);
    this.accountSettings = settings.accountSettings;
    this.appInfo = this.$store.getters.getAppInfo;
    this.loadDefaultEmail();
    if (typeof settings.emailSettings === 'undefined') {
      this.form = {
        fromName: '',
        fromEmail: '',
        smtpSettings: {
          useSmtp: 0,
          smtpAuthUsername: '',
          smtpAuthPassword: '',
          smtpHost: '',
          smtpEncryption: 'tls',
          smtpAuth: '0'
        }
      };
      return;
    }
    this.form = settings.emailSettings;
  },
  data() {
    return {
      appInfo: {},
      defaultEmail: '',
      accountSettings: {},
      form: {},
      selected: [],
      buttonLoaders: {
        saveChanges: false,
        sendTestEmail: false
      }
    };
  },
  methods: {
    loadDefaultEmail() {
      let payload = {
        requiredData: {
          getDefaultFromEmailV3: 1
        }
      };
      this.$store.dispatch('sendAction', payload).then(response => {
        this.defaultEmail = response.data.getDefaultFromEmailV3;
      });
    },
    save() {
      this.buttonLoaders.saveChanges = true;
      let payload = {};
      payload.requiredData = {
        updateSettingsAllV3: {
          emailSettings: this.form
        },
        getSettingsAllV3: 1
      };
      this.$store.dispatch('sendAction', payload).then(response => {
        this.buttonLoaders.saveChanges = false;
        this.$store.commit('SET_SETTINGS', response.data.getSettingsAllV3);
      });
    },
    sendTestEmail() {
      this.buttonLoaders.sendTestEmail = true;
      let payload = {};
      payload.requiredData = {
        saveTestSmtpSettings: this.form
      };
      this.$store.dispatch('sendAction', payload).then(response => {
        this.$store
          .dispatch('sendAction', { requiredData: { testSendMail: 1 } })
          .then(response => {
            this.buttonLoaders.sendTestEmail = false;
            
          });
      });
    }
  }
};
</script>

<style scoped>
.custom-control {
  width: auto;
}
</style>
